import { Commit } from 'vuex';
import * as Types from './types';
import * as API from './api';
import { Toast } from 'vant';
import { IEventUser, IEventState, IEventDetail, IParamsBusinessUnitList, IParamsDepartmentUsers } from './interface';

const state: IEventState = {
    loadingAddEvent: false,
    addEventResult: {},
    loadingEventDetail: false,
    eventDetail: {} as any,
    loadingUserList: false,
    userList: [],
    loadingOpportunity: false,
    opportunityList: [],
    loadingDelete: false,
    deleteResult: {},
    loadingProject: false,
    projectList: [],
    loadingTask: false,
    taskList: [],
    roomLoading: false,
    roomList: [],
    loadingWorkTime: false,
    workTimeInfo: {} as any,
    loadingTaskItem: false,
    taskItemList: [],
    formdataBind: {},
    loadingDepart: false,
    departmentUsers: [],
    loadingBusiness: false,
    businessUnitList: [],
};

const actions = {
    [Types.FORMDATA_BIND](context: { commit: Commit; state: IEventState }, params: any) {
        context.commit(Types.FORMDATA_BIND, params);
    },
    async [Types.QUERY_EVENT](context: { commit: Commit; state: IEventState }, eventGUID: string) {
        context.commit(Types.QUERY_EVENT_REQUEST);
        const result = await API.queryEvent({ eventGUID });
        context.commit(Types.QUERY_EVENT, result);
    },
    async [Types.SEARCH_EVENT_USER](context: { commit: Commit; state: IEventState }, keyword: string) {
        let userList: any = [];
        context.commit(Types.SEARCH_EVENT_USER, { loading: true, userList });
        userList = await API.searchEventUser({ userInfo: keyword });
        context.commit(Types.SEARCH_EVENT_USER, { loading: false, userList });
    },
    async [Types.SEARCH_EMAIL_USER](context: { commit: Commit; state: IEventState }, keyword: string) {
        let userList: any = [];
        context.commit(Types.SEARCH_EMAIL_USER, { loading: true, userList });
        userList = await API.searchEmailUser({ userInfo: keyword });
        context.commit(Types.SEARCH_EMAIL_USER, { loading: false, userList });
    },
    async [Types.ADD_EVENT](context: { commit: Commit; state: IEventState }, params: { operType: number; data: IEventDetail }) {
        let result = {};
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '保存中...',
        });
        context.commit(Types.ADD_EVENT, { loading: true, result });
        result = await API.addEvent(params);
        setTimeout(() => {
            Toast.clear();
            context.commit(Types.ADD_EVENT, { loading: false, result });
        }, 500);
    },
    async [Types.GET_BUSINESS_OPPORTUNITY](context: { commit: Commit; state: IEventState }, params: { UserCode: string; Type: string; keyword: string }) {
        let opportunityList: any = [];
        context.commit(Types.GET_BUSINESS_OPPORTUNITY, { loading: true, opportunityList });
        opportunityList = await API.getBusinessOpportunity(params);
        context.commit(Types.GET_BUSINESS_OPPORTUNITY, { loading: false, opportunityList });
    },
    async [Types.DELETE_EVENT](context: { commit: Commit; state: IEventState }, params: any) {
        let result = {};
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '删除中...',
        });
        context.commit(Types.DELETE_EVENT, { loading: true, result });
        result = await API.deleteEvent(params);
        setTimeout(() => {
            context.commit(Types.DELETE_EVENT, { loading: false, result });
        }, 500);
    },
    async [Types.GET_PROJECT](context: { commit: Commit; state: IEventState }, params: any) {
        let projectList: any = [];
        context.commit(Types.GET_PROJECT, { loading: true, projectList });
        projectList = await API.getProjInfoWithValid(params);
        context.commit(Types.GET_PROJECT, { loading: false, projectList });
    },
    async [Types.GET_PEOJECT_TASK](context: { commit: Commit; state: IEventState }, projectId: string) {
        let taskList: any = [];
        context.commit(Types.GET_PEOJECT_TASK, { loading: true, taskList });
        taskList = await API.getProjectTask({ projectId });
        context.commit(Types.GET_PEOJECT_TASK, { loading: false, taskList });
    },
    async [Types.GET_MEETING_ROOM](context: { commit: Commit; state: IEventState }, params: any) {
        let roomList: any = [];
        context.commit(Types.GET_MEETING_ROOM, { loading: true, roomList });
        roomList = await API.getMeetingRoom({ eventGUID: params.eventGUID, startDate: params.startDate, endDate: params.endDate });
        if (params.keyword !== '') {
            for (const item of roomList) {
                if (item.equipmentName.indexOf(params.keyword) === -1) {
                    if (item.equipmentInfo && item.equipmentInfo.length > 0) {
                        item.equipmentInfo = item.equipmentInfo.filter((it: any) => it.equipmentName.indexOf(params.keyword) > -1);
                    }
                }
            }
            roomList = roomList.filter((it: any) => it.equipmentInfo.length > 0 || it.equipmentName.indexOf(params.keyword) > -1);
        }
        if (params.usable) {
            for (const item of roomList) {
                if (item.equipmentInfo && item.equipmentInfo.length > 0) {
                    item.equipmentInfo = item.equipmentInfo.filter((it: any) => it.scheduled === 0);
                }
            }
            roomList = roomList.filter((it: any) => it.equipmentInfo.length > 0);
        }
        context.commit(Types.GET_MEETING_ROOM, { loading: false, roomList });
    },
    async [Types.GET_REMAINING_WORKTIME](context: { commit: Commit; state: IEventState }, params: any) {
        let workTimeInfo: any = {};
        context.commit(Types.GET_REMAINING_WORKTIME, { loading: true, workTimeInfo });
        workTimeInfo = await API.getRemainingWorkTime(params);
        context.commit(Types.GET_REMAINING_WORKTIME, { loading: false, workTimeInfo });
    },
    async [Types.GET_TASK_ITEM_OPTIONS](context: { commit: Commit; state: IEventState }, params: any) {
        let taskItemList: any = [];
        context.commit(Types.GET_TASK_ITEM_OPTIONS, { loading: true, taskItemList });
        taskItemList = await API.getTaskItemOptions(params);
        context.commit(Types.GET_TASK_ITEM_OPTIONS, { loading: false, taskItemList });
    },
    async [Types.GET_BUSINESS_UNIT_LIST](context: { commit: Commit; state: IEventState }, params: IParamsBusinessUnitList) {
        let result: any = [];
        context.commit(Types.GET_BUSINESS_UNIT_LIST, { loading: true, result });
        result = await API.getBusinessUnitList(params);
        context.commit(Types.GET_BUSINESS_UNIT_LIST, { loading: false, result });
    },
    async [Types.GET_DEPART_MEND_USERS](context: { commit: Commit; state: IEventState }, params: IParamsDepartmentUsers) {
        let result: any = [];
        context.commit(Types.GET_DEPART_MEND_USERS, { loading: true, result });
        result = await API.getDepartmentUsers(params);
        setTimeout(() => context.commit(Types.GET_DEPART_MEND_USERS, { loading: false, result }), 300);
    },
};

const mutations = {
    [Types.FORMDATA_BIND](state: IEventState, payload: any) {
        state.formdataBind = payload;
    },
    [Types.QUERY_EVENT_REQUEST](state: IEventState) {
        state.loadingEventDetail = true;
    },
    [Types.QUERY_EVENT](state: IEventState, eventDetail: IEventDetail) {
        state.loadingEventDetail = false;
        state.eventDetail = eventDetail;
    },
    [Types.SEARCH_EVENT_USER](state: IEventState, payload: { loading: boolean; userList: IEventUser[] }) {
        state.loadingUserList = payload.loading;
        if (payload.userList) state.userList = payload.userList;
    },
    [Types.SEARCH_EMAIL_USER](state: IEventState, payload: { loading: boolean; userList: IEventUser[] }) {
        state.loadingUserList = payload.loading;
        if (payload.userList) state.userList = payload.userList;
    },
    [Types.ADD_EVENT](state: IEventState, payload: any) {
        state.loadingAddEvent = payload.loading;
        state.addEventResult = payload.result;
    },
    [Types.GET_BUSINESS_OPPORTUNITY](state: IEventState, payload: any) {
        state.loadingOpportunity = payload.loading;
        if (payload.opportunityList) state.opportunityList = payload.opportunityList;
    },
    [Types.DELETE_EVENT](state: IEventState, payload: any) {
        state.loadingDelete = payload.loading;
        state.deleteResult = payload.result;
    },
    [Types.GET_PROJECT](state: IEventState, payload: any) {
        state.loadingProject = payload.loading;
        state.projectList = payload.projectList;
    },
    [Types.GET_PEOJECT_TASK](state: IEventState, payload: any) {
        state.loadingTask = payload.loading;
        state.taskList = payload.taskList;
    },
    [Types.GET_MEETING_ROOM](state: IEventState, payload: any) {
        state.roomLoading = payload.loading;
        state.roomList = payload.roomList;
    },
    [Types.GET_REMAINING_WORKTIME](state: IEventState, payload: any) {
        state.loadingWorkTime = payload.loading;
        state.workTimeInfo = payload.workTimeInfo;
    },
    [Types.GET_TASK_ITEM_OPTIONS](state: IEventState, payload: any) {
        state.loadingTaskItem = payload.loading;
        state.taskItemList = payload.taskItemList;
    },
    [Types.GET_BUSINESS_UNIT_LIST](state: IEventState, payload: any) {
        state.loadingBusiness = payload.loading;
        state.businessUnitList = payload.result;
    },
    [Types.GET_DEPART_MEND_USERS](state: IEventState, payload: any) {
        state.loadingDepart = payload.loading;
        state.departmentUsers = payload.result;
    },
};

export default { namespaced: true, state, actions, mutations };
